export function useKeyboardClick(element: HTMLElement, keys = ["Enter", " "]) {
	const handleKeyDown = (event: KeyboardEvent) => {
		if (keys.indexOf(event.key) !== -1) {
			event.stopPropagation();
			element.click();
		}

		element.removeEventListener("keydown", handleKeyDown, false);
	};

	const handleKeyUp = () => {
		element.addEventListener("keydown", handleKeyDown, false);
	};

	element.addEventListener("keyup", handleKeyUp, false);
	element.addEventListener("keydown", handleKeyDown, false);

	return function useEscapeCleanup() {
		element.removeEventListener("keyup", handleKeyUp, false);
		element.removeEventListener("keydown", handleKeyDown, false);
	};
}

export function useEscapeKey(element: HTMLElement | Document, callback: (event: KeyboardEvent) => void) {
	const handleKeyDown = (event: KeyboardEvent) => {
		if (["Escape"].indexOf(event.key) !== -1) {
			event.stopPropagation();
			callback(event);
		}

		element.removeEventListener("keydown", handleKeyDown, false);
	};

	const handleKeyUp = () => {
		element.addEventListener("keydown", handleKeyDown, false);
	};

	element.addEventListener("keyup", handleKeyUp, false);
	element.addEventListener("keydown", handleKeyDown, false);

	return function useEscapeCleanup() {
		element.removeEventListener("keyup", handleKeyUp, false);
		element.removeEventListener("keydown", handleKeyDown, false);
	};
}
